enum BuySellFXWalletType {
    ExistingWallet = "EXISTING_WALLET",
    NewWallet = "NEW_WALLET"
}
export default BuySellFXWalletType